import { Helmet } from "react-helmet-async";

// SeoHelmet 元件現在只負責 Google Analytics 追蹤
// Meta 標籤（title, description, canonical, og:tags）由 PageMeta 元件處理
const SeoHelmet = () => {
  return (
    <>
      <Helmet>
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=AW-10861009790"
        ></script>
        <script>
          {` window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-10861009790");`}
        </script>
        <script>
          {`  window.addEventListener("load", function(event) {
        document.querySelectorAll('[href*="tel:"]').forEach(function(e) {
          e.addEventListener("click", function() {
            gtag("event", "conversion", {
              send_to: "AW-10861009790/duhgCP6I38MZEP6297oo",
            });
          });
        });
      });`}
        </script>
        <script>
          {` window.addEventListener("load", function(event) {
        document
          .querySelectorAll('[href^="https://lin.ee/"]')
          .forEach(function(e) {
            e.addEventListener("click", function() {
              gtag("event", "conversion", {
                send_to: "AW-10861009790/7Ym6CPuI38MZEP6297oo",
              });
            });
          });
      });`}
        </script>
        <script>
          {`      window.addEventListener("load", function(event) {
        document
          .querySelector(
            "#root > div > div > div > div.fixed.right-\\[11px\\].bottom-\\[205px\\].w-\\[64px\\].h-\\[64px\\].z-20 > button > div"
          )
          .addEventListener("click", function() {
            gtag("event", "conversion", {
              send_to: "AW-10861009790/7Ym6CPuI38MZEP6297oo",
            });
          });
      });`}
        </script>
        <script>
          {` window.addEventListener("load", function(event) {
        if (window.location.href.includes("/received")) {
          gtag("event", "conversion", {
            send_to: "AW-10861009790/K6JKCIGJ38MZEP6297oo",
          });
        }
      });`}
        </script>
      </Helmet>
    </>
  );
};
export default SeoHelmet;
